// src/services/accounting.js
const API_URL = 'https://new.sbdemolition.online/api';

const handleResponse = async (response) => {
  const text = await response.text();
  if (text.startsWith('<')) {
    console.error('API returned HTML:', text);
    throw new Error('Server returned an error. Check server logs.');
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    console.error('Invalid JSON:', text);
    throw new Error('Invalid server response');
  }
};

const fetchOptions = () => {
  const token = localStorage.getItem('authToken');
  return {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    }
  };
};

export const accountingAPI = {
  // 👈 القديم: مشروع واحد
  getProjectAccounting: async (projectId) => {
    const response = await fetch(
      `${API_URL}/accounting/project-accounting-list.php?projectId=${projectId}`,
      {
        method: 'GET',
        ...fetchOptions()
      }
    );
    return handleResponse(response);
  },

  // 👈 الجديد: كل المشاريع (يستخدم project-accounting-list-all.php)
  getAllAccounting: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await fetch(
      `${API_URL}/accounting/project-accounting-list-all.php${query ? `?${query}` : ''}`,
      {
        method: 'GET',
        ...fetchOptions()
      }
    );
    return handleResponse(response);
  },

  createRecord: async (data) => {
    const response = await fetch(`${API_URL}/accounting/project-accounting.php`, {
      method: 'POST',
      ...fetchOptions(),
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  updateRecord: async (id, data) => {
    const response = await fetch(`${API_URL}/accounting/project-accounting.php`, {
      method: 'PUT',
      ...fetchOptions(),
      body: JSON.stringify({ id, ...data })
    });
    return handleResponse(response);
  },

  updateStatus: async (id, status) => {
    const response = await fetch(`${API_URL}/accounting/project-accounting.php`, {
      method: 'PUT',
      ...fetchOptions(),
      body: JSON.stringify({ id, status })
    });
    return handleResponse(response);
  },

  deleteRecord: async (recordId) => {
    const response = await fetch(
      `${API_URL}/accounting/project-accounting.php?id=${recordId}`,
      {
        method: 'DELETE',
        ...fetchOptions()
      }
    );
    return handleResponse(response);
  },

  // ✅ رفع ملف مع تحديد النوع (income أو expense)
  uploadFile: async (file, type) => {
    const token = localStorage.getItem('authToken');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type); // income أو expense

    const response = await fetch(`${API_URL}/accounting/upload-file.php`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        ...(token && { Authorization: `Bearer ${token}` })
        // ⚠️ لا تضيف Content-Type مع FormData
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Upload failed' }));
      throw new Error(error.error || 'File upload failed');
    }

    return response.json();
  },

  // ✅ حذف ملف من السيرفر
  deleteFile: async (fileName, type) => {
    const response = await fetch(`${API_URL}/accounting/delete-file.php`, {
      method: 'POST',
      ...fetchOptions(),
      body: JSON.stringify({ fileName, type })
    });
    return handleResponse(response);
  },

  getOverhead: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_URL}/accounting/overhead.php?${queryString}`, {
      method: 'GET',
      ...fetchOptions()
    });
    return handleResponse(response);
  },

  createOverhead: async (data) => {
    const response = await fetch(`${API_URL}/accounting/overhead.php`, {
      method: 'POST',
      ...fetchOptions(),
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  deleteOverhead: async (expenseId) => {
    const response = await fetch(`${API_URL}/accounting/overhead.php?id=${expenseId}`, {
      method: 'DELETE',
      ...fetchOptions()
    });
    return handleResponse(response);
  }
};

export default accountingAPI;
